import { Mail, MapPin, Phone } from "lucide-react";
import { Reveal, RevealWords, Overline } from "./shared";
import ContactForm from "./ContactForm";

export default function Contact() {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative mx-auto max-w-7xl px-6 py-16 md:py-24"
    >
      <div className="grid gap-14 lg:grid-cols-2">
        <div>
          <Reveal>
            <Overline>Get in touch</Overline>
          </Reveal>
          <RevealWords
            text="Let's build something reliable together"
            className="font-display mt-5 text-4xl font-semibold leading-tight text-white md:text-5xl"
          />
          <Reveal delay={0.2}>
            <p className="mt-6 max-w-md text-[#a0aec0]">
              Tell us about your project or challenge. Whether it&apos;s hardware, cloud,
              security or design — we&apos;ll get back to you fast.
            </p>
          </Reveal>

          <div className="mt-10 space-y-5">
            {[
              [Mail, "Email", "sales@gabicomitsolutions.com"],
              [Phone, "Phone", "1.202.309.2266"],
              [MapPin, "Office", "8401 Decatur Trotter Place, Glenarden, Maryland 20706"],
            ].map(([Icon, label, value]) => (
              <Reveal key={label} delay={0.25}>
                <div className="flex items-center gap-4">
                  <div className="flex h-12 w-12 items-center justify-center rounded-xl border border-white/10 bg-white/5 text-[#00f0ff]">
                    <Icon className="h-5 w-5" />
                  </div>
                  <div>
                    <p className="font-mono-tech text-xs uppercase tracking-widest text-[#a0aec0]">
                      {label}
                    </p>
                    <p className="text-white">{value}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <ContactForm />
        </Reveal>
      </div>
    </section>
  );
}
